import React from 'react';
import SolutionInstallmentExaminationReviewWrapper from 'components/SolutionInstallmentExaminationReviewWrapper/SolutionInstallmentExaminationReviewWrapper';

export default function SolutionInstallmentExaminationReviewContainer() {
    return (
        <SolutionInstallmentExaminationReviewWrapper />
    )
}
